module.exports = __webpack_public_path__ + "964f88e1a0838330563819b05b2802bb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/reading/book-covers/book-6.png
// module id = 3597
// module chunks = 0